/**
 * Plain words for internal codes that reach an analyst's screen (AIC-557). The codes themselves stay as they are in
 * storage and in the API; only what is displayed changes. Keep every entry in step with the enum it names.
 */
import type { redFlagCategory } from "./tools/catalog.ts";

const sentence = (s: string) => s.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());

/** A field's unit (tracker-data Unit, plus the insights' pct / pp). */
export const UNIT_LABEL: Readonly<Record<string, string>> = {
  usd_m: "USD millions",
  percent: "Percent",
  pct: "Percent",
  pp: "Percentage points",
  count: "Count",
  text: "Text",
  month: "Month",
};
/** "usd_m" → "USD millions"; an unknown unit is shown as words, never as the code. */
export const unitLabel = (unit: string | null | undefined): string | null => (unit ? UNIT_LABEL[unit] ?? sentence(unit).toLowerCase() : null);

/** A verifier red flag / stored concern type (tools/catalog.ts redFlagCategory) as a plain heading. */
export const CONCERN_TYPE_LABEL: Readonly<Record<(typeof redFlagCategory.options)[number], string>> = {
  ai_identity_challenge_mishandled: "AI identity question handled poorly",
  confidentiality_trigger_missed: "Confidentiality request missed",
  stt_misrecognition: "Speech-to-text may have misheard",
  implausible_figure_unchallenged: "Implausible figure not challenged",
  consent_not_explicit: "Recording consent not explicit",
  basis_mismatch: "Basis mismatch",
  other: "Other",
};
/** An unknown type still reads as words, never as the code. */
export const concernTypeLabel = (type: string): string => (CONCERN_TYPE_LABEL as Record<string, string>)[type] ?? sentence(type);
